// Hydrate the slice from localStorage (called on app boot).
export const HYDRATE_ACTIVE_CONTEXT = 'HYDRATE_ACTIVE_CONTEXT';

// Switch the active organization context (or to/from Global View).
export const SWITCH_CONTEXT = 'SWITCH_CONTEXT';
export const SWITCH_CONTEXT_SUCCESS = 'SWITCH_CONTEXT_SUCCESS';
export const SWITCH_CONTEXT_FAIL = 'SWITCH_CONTEXT_FAIL';

export const CLEAR_ACTIVE_CONTEXT_ERROR = 'CLEAR_ACTIVE_CONTEXT_ERROR';

// Reconcile memberships[].hasAggregateView against the authoritative set of
// org IDs returned by GET /global/sub-organizations. Lets the sidebar's
// "(N orgs)" count stay in sync after a role change without a re-login.
export const REFRESH_AGGREGATE_VIEW_ORGS = 'REFRESH_AGGREGATE_VIEW_ORGS';

// Pull the full active-context envelope from GET /auth/active-context. Used
// to recover from stale client state when memberships are granted/revoked or
// org:aggregate-view changes mid-session — fixes the "stuck on global
// dashboard until logout" and "new org doesn't appear until logout" bugs.
export const REFRESH_ACTIVE_CONTEXT = 'REFRESH_ACTIVE_CONTEXT';
export const REFRESH_ACTIVE_CONTEXT_SUCCESS = 'REFRESH_ACTIVE_CONTEXT_SUCCESS';
export const REFRESH_ACTIVE_CONTEXT_FAIL = 'REFRESH_ACTIVE_CONTEXT_FAIL';
